import { Drawer, IconButton, Stack, Typography } from "@mui/material";
import { FC, useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import { providerConnectionsDrawerOpenSelector } from "@/store/provider-connections/selectors/providerConnectionsDrawerOpenSelector";
import { activeProviderConnectionTypeSelector } from "@/store/provider-connections/selectors/active-connection/activeProviderConnectionTypeSelector";
import { setActiveProviderConnectionType } from "@/store/provider-connections/providerConnectionsSlice";

import { providerConnectionDetails } from "@/components/pages/integrations/components/provider-connections/common/utils/constants/ProviderConnectionDetails";
import { SnowflakeConnectionDrawer } from "@/components/pages/integrations/components/provider-connections/snowflake/components/drawer/SnowflakeConnectionDrawer";

export const ProviderConnectionDrawer: FC = () => {
  const dispatch = useAppDispatch();
  const open = useAppSelector(providerConnectionsDrawerOpenSelector);
  const type = useAppSelector(activeProviderConnectionTypeSelector);

  const closeHandler = useCallback(() => {
    dispatch(setActiveProviderConnectionType(null));
  }, [dispatch]);

  const drawerHeading = type ? providerConnectionDetails[type].drawerTitle : "";

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeHandler}
      PaperProps={paperProps}
      slotProps={slotProps}
    >
      <Stack
        py={1.25}
        px={2}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        position="sticky"
        top={0}
        borderBottom={1}
        borderColor="grey.300"
        bgcolor="white"
        zIndex={(theme) => theme.zIndex.drawer}
      >
        <Typography variant="body1">{drawerHeading}</Typography>
        <IconButton size="small" onClick={closeHandler}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>

      {type === "snowflake" && (
        <SnowflakeConnectionDrawer onClose={closeHandler} />
      )}
    </Drawer>
  );
};

const slotProps = {
  backdrop: {
    invisible: true,
  },
};

const paperProps = {
  sx: {
    width: "50dvw",
    minWidth: 670,
    maxWidth: 1000,
  },
};
